import React from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import Hero from './components/Hero';
import ProductCategories from './components/ProductCategories';
import Features from './components/Features';
import CTA from './components/CTA';

const ManageEnginePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <ProductCategories />
      <Features />
      <CTA />
      <Footer />
    </div>
  );
};

export default ManageEnginePage;